/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramGeoControllerGetTreeQueryResponse } from '../types/TelegramGeoControllerGetTree.ts';

function getTelegramGeoGetTreeUrl() {
  const res = { method: 'GET', url: `/api/telegram/geo/tree` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/tree}
 */
export async function telegramGeoGetTree(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoControllerGetTreeQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoGetTreeUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
